export class RightsFamily {
  rights_family_id: number;
  rights_family_name: string;
  rights_family_parent_id: number;
  rights_family_parent_name: string;
  children: RightsFamily[];
}
